import { BUSCAR_ULTIMOS_HISTORICOS_ROTA, LIMPAR_ULTIMOS_HISTORICOS_ROTA } from '../../actions/types'

const initialState = undefined

export default function reducerUltimosHistoricosRota (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_ULTIMOS_HISTORICOS_ROTA: {
      const historicos = action.payload.data;
      if (historicos) {
        return  historicos;
      }
      return []
    }

    case LIMPAR_ULTIMOS_HISTORICOS_ROTA:
        return [];
    
    default: {
      return state
    }
  }
}
